module.exports = __webpack_public_path__ + "static/media/YM23_0.8ea48552.jpg";